/* Calendário de reserva por data (wecheerUP) — vanilla JS, sem dependências.
   Lê datas ocupadas do metafield custom.booked_dates, desabilita datas passadas
   e ocupadas, e grava a data escolhida na line item property "Data do evento". */
(function () {
  var MONTHS = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  var WD = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];

  function iso(y, m, d) {
    return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }

  function parseBooked(raw) {
    var map = {};
    try {
      var arr = JSON.parse(raw || '[]');
      (arr || []).forEach(function (x) {
        var s = typeof x === 'string' ? x : (x && x.value ? x.value : '');
        s = (s || '').slice(0, 10);
        if (s) map[s] = true;
      });
    } catch (e) {}
    return map;
  }

  function initCalendar(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var wrap = box.closest('[data-booking]');
    if (!wrap) return;
    var input = wrap.querySelector('.booking__input');
    var selectedLabel = wrap.querySelector('.booking__selected');
    var errorEl = wrap.querySelector('.booking__error');
    var booked = parseBooked(box.getAttribute('data-booked'));

    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var view = new Date(today.getFullYear(), today.getMonth(), 1);
    var selected = null;

    var cal = document.createElement('div');
    cal.className = 'bc';
    box.appendChild(cal);

    function render() {
      var y = view.getFullYear(), m = view.getMonth();
      var first = new Date(y, m, 1).getDay();
      var days = new Date(y, m + 1, 0).getDate();
      var canPrev = !(y === today.getFullYear() && m === today.getMonth());
      var h = '<div class="bc__head">' +
        '<button type="button" class="bc__nav" data-prev ' + (canPrev ? '' : 'disabled') + ' aria-label="Mês anterior">&lsaquo;</button>' +
        '<span class="bc__month">' + MONTHS[m] + ' ' + y + '</span>' +
        '<button type="button" class="bc__nav" data-next aria-label="Próximo mês">&rsaquo;</button></div>';
      h += '<div class="bc__grid">';
      WD.forEach(function (w) { h += '<div class="bc__wd">' + w + '</div>'; });
      for (var i = 0; i < first; i++) h += '<button type="button" class="bc__day is-empty" disabled></button>';
      for (var d = 1; d <= days; d++) {
        var ds = iso(y, m, d);
        var date = new Date(y, m, d);
        var disabled = date < today || booked[ds];
        var sel = selected === ds ? ' is-selected' : '';
        h += '<button type="button" class="bc__day' + sel + '" data-date="' + ds + '"' + (disabled ? ' disabled' : '') + '>' + d + '</button>';
      }
      h += '</div>';
      cal.innerHTML = h;
    }

    cal.addEventListener('click', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-prev')) { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); return; }
      if (t.hasAttribute('data-next')) { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); return; }
      if (t.classList.contains('bc__day') && !t.disabled && t.dataset.date) {
        selected = t.dataset.date;
        if (input) { input.value = selected; input.dispatchEvent(new Event('change', { bubbles: true })); }
        var p = selected.split('-');
        if (selectedLabel) selectedLabel.textContent = 'Data escolhida: ' + p[2] + '/' + p[1] + '/' + p[0];
        if (errorEl) errorEl.classList.remove('show');
        render();
      }
    });

    render();

    // Bloqueia adicionar ao carrinho sem data (fase de captura, antes do handler do tema)
    var form = wrap.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!input || !input.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (errorEl) errorEl.classList.add('show');
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }
  }

  function boot() {
    document.querySelectorAll('.booking__calendar').forEach(initCalendar);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
